import type React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import SubscriptionBanner from '@/components/billing/SubscriptionBanner';
import { useUIStore } from '@/stores/uiStore';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { cn } from '@/lib/utils';

const AdminLayout: React.FC = () => {
  const { isSidebarOpen, isMobile } = useUIStore();
  useMediaQuery();

  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar />
      <Header />
      <main
        className={cn(
          'pt-16 min-h-screen transition-all duration-300',
          !isMobile && (isSidebarOpen ? 'ml-64' : 'ml-[72px]'),
        )}
      >
        <SubscriptionBanner />
        <div className={cn(isMobile ? 'p-4' : 'p-6')}>
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
